(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bundle-builder"] && !Shopify.designMode) return;
  try {
    
(function () {
  const FMT = new Intl.NumberFormat(document.documentElement.lang || 'fr-FR', { style: 'currency', currency: 'EUR' });
  const money = (cents) => FMT.format(cents / 100);
  const HEADER_SELECTORS = '.header-section, sticky-header, .site-header, header[role="banner"], .header-wrapper, [id$="__header"], #shopify-section-header';

  function initBundle(root) {
    if (!root || root.dataset.bundleReady === '1') return;
    root.dataset.bundleReady = '1';
    const I18N = (() => { try { return JSON.parse(root.querySelector('[data-bundle-i18n]').textContent); } catch (e) { return {}; } })();
    const I18N_DEC = document.createElement('textarea');
    const tr = (k, fb, vars) => { let s = fb; if (I18N[k]) { I18N_DEC.innerHTML = I18N[k]; s = I18N_DEC.value; } if (vars) Object.keys(vars).forEach((v) => { s = s.split('[' + v + ']').join(vars[v]); }); return s; };

    const TIERS = JSON.parse(root.dataset.tiers || '[]').sort((a, b) => a.min - b.min);
    const GIFT_AMOUNT = parseFloat(root.dataset.giftAmount || '0') * 100;
    const GIFT_VARIANT = (root.dataset.giftVariant || '').trim();
    const AFTER_ADD = root.dataset.afterAdd || 'cart';

    /** variantId -> { qty, price, max, title, variant, img } */
    const state = new Map();

    const $ = (sel, ctx) => (ctx || root).querySelector(sel);
    const $$ = (sel, ctx) => Array.from((ctx || root).querySelectorAll(sel));

    const els = {
      lines: $('[data-bundle-lines]'),
      empty: $('[data-bundle-empty]'),
      count: $('[data-bundle-count]'),
      subtotal: $('[data-bundle-subtotal]'),
      savingRow: $('[data-bundle-saving-row]'),
      saving: $('[data-bundle-saving]'),
      savingPct: $('[data-bundle-saving-pct]'),
      total: $('[data-bundle-total]'),
      handleTotal: $('[data-bundle-handle-total]'),
      submit: $('[data-bundle-submit]'),
      error: $('[data-bundle-error]'),
      fill: $('[data-bundle-progress-fill]'),
      label: $('[data-bundle-progress-label]'),
      progress: $('[data-bundle-progress]'),
      gift: $('[data-bundle-gift]'),
      summary: $('[data-bundle-summary]'),
      _page: document.body.classList.add('bb-page'),
      go: $$('[data-bundle-checkout]'),
      goMeta: $('[data-bundle-go-meta]')
    };
    const GO_TARGET = '/cart';
    /* Hauteur réelle de la barre du bas (mobile/tablette) : le bouton « retour en haut » se place au-dessus */
    const barEl = $('.bb-summary__bar');
    const syncBarH = () => { if (barEl) document.documentElement.style.setProperty('--bb-bar-h', barEl.getBoundingClientRect().height + 'px'); };
    syncBarH();
    window.addEventListener('resize', syncBarH, { passive: true });
    window.addEventListener('load', syncBarH, { once: true });
    if ('ResizeObserver' in window && barEl) new ResizeObserver(syncBarH).observe(barEl);

    /* ---- Récap mobile/tablette : feuille basse avec fond sombre, page derrière bloquée ---- */
    const MQ_SHEET = window.matchMedia('(max-width:1023px)');
    const sheetBody = $('[data-bundle-body]');
    const backdrop = document.createElement('div');
    backdrop.className = 'bb-backdrop';
    backdrop.setAttribute('aria-hidden', 'true');
    els.summary.parentNode.insertBefore(backdrop, els.summary);
    function setSheet(open) {
      const on = !!open && MQ_SHEET.matches;
      els.summary.classList.toggle('is-open', on);
      const tg = $('[data-bundle-toggle]');
      if (tg) tg.setAttribute('aria-expanded', on ? 'true' : 'false');
      backdrop.classList.toggle('is-on', on);
      const html = document.documentElement;
      html.classList.toggle('bb-lock', on);
      /* Le récap passe devant tout (barre de progression, header) ; on garde ce niveau le temps du fondu de fermeture */
      clearTimeout(setSheet.t);
      if (on) html.classList.add('bb-sheet-up');
      else setSheet.t = setTimeout(() => html.classList.remove('bb-sheet-up'), 280);
    }
    /* iOS ignore parfois overflow:hidden : on bloque le glissé hors de la liste du récap */
    const blockMove = (e) => {
      if (!document.documentElement.classList.contains('bb-lock')) return;
      if (sheetBody && sheetBody.contains(e.target) && sheetBody.scrollHeight > sheetBody.clientHeight) return;
      e.preventDefault();
    };
    backdrop.addEventListener('touchmove', blockMove, { passive: false });
    els.summary.addEventListener('touchmove', blockMove, { passive: false });
    backdrop.addEventListener('click', () => setSheet(false));
    document.addEventListener('keydown', (e) => { if (e.key === 'Escape' && els.summary.classList.contains('is-open')) setSheet(false); });
    const onMq = () => { if (!MQ_SHEET.matches) setSheet(false); };
    if (MQ_SHEET.addEventListener) MQ_SHEET.addEventListener('change', onMq); else if (MQ_SHEET.addListener) MQ_SHEET.addListener(onMq); /* « Valider mon bundle » : page panier (récap + CGV avant paiement) */

    /* ---- Barre de progression : se cale sous le header, même s'il se replie ---- */
    const header = document.querySelector(HEADER_SELECTORS);
    let lastTop = -1;
    let ticking = false;
    function syncSticky() {
      ticking = false;
      let top = 0;
      if (header) {
        const r = header.getBoundingClientRect();
        if (r.bottom > 0 && r.bottom < 260) top = Math.round(r.bottom);
      }
      if (top !== lastTop) {
        root.style.setProperty('--bb-sticky-top', top + 'px');
        lastTop = top;
      }
      if (els.progress) {
        const p = els.progress.getBoundingClientRect();
        els.progress.classList.toggle('is-stuck', p.top <= top + 1 && root.getBoundingClientRect().top < top);
      }
    }
    function onScroll() {
      if (!ticking) { ticking = true; requestAnimationFrame(syncSticky); }
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
    syncSticky();

    /* ---- Message « ajouté » (visible sur mobile) ---- */
    let toastEl = null;
    let toastTimer = 0;
    function toast(msg) {
      if (!toastEl) {
        toastEl = document.createElement('div');
        toastEl.className = 'bb-toast';
        toastEl.setAttribute('role', 'status');
        toastEl.setAttribute('aria-live', 'polite');
        root.appendChild(toastEl);
      }
      toastEl.textContent = msg;
      toastEl.classList.remove('is-on');
      void toastEl.offsetWidth;
      toastEl.classList.add('is-on');
      clearTimeout(toastTimer);
      toastTimer = setTimeout(() => toastEl.classList.remove('is-on'), 1800);
    }

    /* ---- Lecture de l'option sélectionnée sur une carte ---- */
    function readCard(card) {
      const opt = card.querySelector('[data-bundle-variant-opt].is-selected');
      const single = card.querySelector('[data-bundle-variant-single]');
      const src = opt || single;
      if (!src) return null;
      const img = card.querySelector('.bb-card__media img');
      return {
        id: opt ? opt.dataset.id : single.value,
        price: parseInt(src.dataset.price, 10) || 0,
        max: parseInt(src.dataset.max, 10) || 99,
        title: card.dataset.productTitle || '',
        variant: src.dataset.variantTitle || '',
        img: (opt && opt.dataset.img) || (img ? img.currentSrc || img.src : ''),
        url: card.dataset.productUrl || ''
      };
    }

    /* ---- Image du parfum sélectionné (comme sur la fiche produit) ---- */
    function swapImage(card, opt) {
      const img = card.querySelector('.bb-card__media img');
      const src = opt.dataset.img;
      const vUrl = optUrl(opt);
      if (vUrl) {
        $$('.bb-card__title a', card).forEach((a) => { a.href = vUrl; });
      }
      if (!img || !src || img.getAttribute('src') === src) return;
      img.classList.add('is-swapping');
      const done = () => img.classList.remove('is-swapping');
      img.addEventListener('load', done, { once: true });
      img.addEventListener('error', done, { once: true });
      img.loading = 'eager';
      img.srcset = optSrcset(opt);
      img.src = src;
    }
    /* ---- Options : un groupe par option (goût, batterie, quantité…) ---- */
    const optsOf = (v) => [v.dataset.o1 || '', v.dataset.o2 || '', v.dataset.o3 || ''];
    const variantsOf = (card) => $$('[data-bundle-variant-opt]', card);
    const selectedOf = (card) => card.querySelector('[data-bundle-variant-opt].is-selected');
    /* Variantes : URL, srcset et miniature recalculés depuis data-img (HTML plus léger) */
    const imgW = (u, w) => (u ? u.replace(/([?&]width=)\d+/, '$1' + w) : '');
    const optSrcset = (o) => (o && o.dataset.img ? imgW(o.dataset.img, 300) + ' 300w, ' + imgW(o.dataset.img, 500) + ' 500w' : '');
    const optThumb = (o) => (o && o.dataset.img ? imgW(o.dataset.img, 120) : '');
    const optUrl = (o) => { const c = o && o.closest('[data-bundle-card]'); return c && c.dataset.productUrl ? c.dataset.productUrl + (c.dataset.productUrl.indexOf('?') > -1 ? '&' : '?') + 'variant=' + o.dataset.id : ''; };
    const esc = (s) => String(s).replace(/[&<>"]/g, (ch) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[ch]));

    /* Variante obtenue en cliquant sur une valeur : on garde les autres choix
       si la combinaison existe, sinon la première variante dispo avec cette valeur. */
    function resolveVariant(card, chip) {
      const group = chip.closest('[data-opt-group]');
      const sel = selectedOf(card);
      if (!group || !sel) return null;
      const idx = parseInt(group.dataset.optGroup, 10) || 0;
      const want = optsOf(sel);
      want[idx] = chip.dataset.optValue;
      const list = variantsOf(card);
      return list.find((v) => optsOf(v).every((o, i) => o === want[i])) ||
        list.find((v) => optsOf(v)[idx] === chip.dataset.optValue) || null;
    }

    /* Met à jour les boutons d'une carte : sélection, combinaisons absentes,
       prix de chaque choix, photo des tuiles Oui / Non selon le goût choisi. */
    function syncChips(card) {
      const sel = selectedOf(card);
      if (!sel) return;
      const cur = optsOf(sel);
      const list = variantsOf(card);
      const varies = list.some((v) => v.dataset.price !== sel.dataset.price);
      $$('[data-opt-group]', card).forEach((g) => {
        const idx = parseInt(g.dataset.optGroup, 10) || 0;
        $$('[data-opt-value]', g).forEach((c) => {
          const on = c.dataset.optValue === cur[idx];
          c.classList.toggle('is-selected', on);
          c.setAttribute('aria-checked', on ? 'true' : 'false');
          c.tabIndex = on ? 0 : -1;
          const want = cur.slice();
          want[idx] = c.dataset.optValue;
          const exact = list.find((v) => optsOf(v).every((o, i) => o === want[i]));
          c.classList.toggle('is-unavailable', !exact);
          const target = exact || list.find((v) => optsOf(v)[idx] === c.dataset.optValue);
          const thumb = c.querySelector('[data-opt-thumb]');
          const tSrc = optThumb(target);
          if (thumb && tSrc && thumb.getAttribute('src') !== tSrc) thumb.src = tSrc;
          const price = c.querySelector('[data-opt-price]');
          if (price) price.textContent = varies && target ? money(parseInt(target.dataset.price, 10) || 0) : '';
        });
        const label = g.querySelector('[data-opt-current]');
        if (label) label.textContent = cur[idx];
      });
    }

    function selectVariant(card, v, silent) {
      variantsOf(card).forEach((x) => x.classList.toggle('is-selected', x === v));
      const p = card.querySelector('[data-bundle-card-price]');
      if (p) p.textContent = money(parseInt(v.dataset.price, 10) || 0);
      syncChips(card);
      swapImage(card, v);
      if (!silent) render();
    }

    /* Préchargement au survol / focus : le changement d'image est instantané */
    const preloaded = new Set();
    function preload(e) {
      const chip = e.target.closest && e.target.closest('[data-opt-value]');
      const card = chip && chip.closest('[data-bundle-card]');
      const v = card && resolveVariant(card, chip);
      if (!v || !v.dataset.img || preloaded.has(v.dataset.img)) return;
      preloaded.add(v.dataset.img);
      const i = new Image();
      i.srcset = optSrcset(v);
      i.sizes = '(max-width: 640px) 45vw, 220px';
      i.src = v.dataset.img;
    }
    root.addEventListener('pointerover', preload, { passive: true });
    root.addEventListener('focusin', preload);

    /* ---- Coup de pouce : 3 produits pour atteindre le palier suivant ---- */
    els.nudge = $('[data-bundle-nudge]');
    els.nudgeTitle = $('[data-bundle-nudge-title]');
    els.nudgeList = $('[data-bundle-nudge-list]');
    let catalog = null;
    let nudgeCards = [];
    let nudgeKey = '';
    function catalogCards() {
      if (!catalog) {
        const map = new Map();
        const keep = (c) => { if (!map.has(c.dataset.productUrl)) map.set(c.dataset.productUrl, c); };
        $$('[data-bundle-panel]:not([data-bundle-all]) [data-bundle-card]').forEach(keep);
        $$('[data-bundle-card]').forEach(keep);
        catalog = Array.from(map.values());
      }
      return catalog;
    }
    function renderNudge(subtotal, count, next) {
      if (!els.nudge) return;
      if (!next || !count) { els.nudge.hidden = true; nudgeKey = ''; return; }
      const gap = next.min * 100 - subtotal;
      const used = new Set();
      state.forEach((l) => used.add(l.url));
      const items = [];
      catalogCards().forEach((c) => {
        if (used.has(c.dataset.productUrl)) return;
        const info = readCard(c);
        if (info && !state.has(info.id)) items.push({ c, info });
      });
      /* Suggestions pondérées par onglet (réglage « Priorité dans les suggestions »), catégories absentes du panier d'abord,
         roulement aléatoire stable tant que le panier ne change pas, au moins un produit qui débloque le palier. */
      const catOf = (c) => { const p = c.closest('[data-bundle-panel]'); return p ? p.dataset.bundlePanel : 'x'; }; const wOf = (c) => { const p = c.closest('[data-bundle-panel]'); const w = p ? parseFloat(p.dataset.nudgeWeight) : NaN; return isNaN(w) ? 1 : w; }; const inCart = new Set(); catalogCards().forEach((c) => { if (used.has(c.dataset.productUrl)) inCart.add(catOf(c)); }); renderNudge.seed = renderNudge.seed || String(Math.random()); const seed = renderNudge.seed + Array.from(used).sort().join(','); const rnd = (s) => { let h = 2166136261; for (let i = 0; i < s.length; i++) { h ^= s.charCodeAt(i); h = Math.imul(h, 16777619); } return ((h >>> 0) % 1000) / 1000; }; const cap = gap + Math.max(2500, gap * 0.8); const hasCartridge = Array.from(used).some((u) => /e-liquide|cartridge|cartouche/i.test(u)); const boostOf = (x) => { const k = (x.c.dataset.productUrl || '') + ' ' + (x.info.title || ''); if (/battery|batterie/i.test(k)) return hasCartridge ? 2.5 : 0.12; const b = /brownie/i.test(k) ? 2.1 : (/tweex|sex-bites|sex bites/i.test(k) ? 1.8 : (/cookie|sirop|syrup|gumm/i.test(k) ? 1.45 : 1)); if (x.c.closest('[data-bundle-solo]')) return gap >= 3000 ? 1.4 : 0.45; const p = x.info.price; return b * (p <= 2500 ? 1.25 : (p >= 6000 ? 0.75 : 1)); }; items.forEach((x) => { const p = x.info.price; const fit = p >= gap ? (p <= cap ? 1.4 : 0.6) : 0.5 + 0.4 * (p / gap); x.cat = catOf(x.c); x.s = wOf(x.c) * boostOf(x) * fit * (inCart.has(x.cat) ? 0.8 : 1) * (0.55 + rnd(seed + x.c.dataset.productUrl)); }); items.sort((a, b) => b.s - a.s);
      renderNudge.gap = gap; renderNudge.pct = next.pct; const optsHtml = (x) => { const os = x.c.querySelectorAll('[data-bundle-variant-opt]'); if (os.length < 2) return ''; return '<select class="bb-nudge__opt" data-nudge-opt aria-label="' + esc(x.info.title) + '">' + Array.from(os).map((o) => '<option value="' + esc(o.dataset.id) + '"' + (String(o.dataset.id) === String(x.info.id) ? ' selected' : '') + '>' + esc(o.dataset.variantTitle || '') + '</option>').join('') + '</select>'; }; if (!renderNudge.bound && els.nudgeList) { renderNudge.bound = true; els.nudgeList.addEventListener('change', (e) => { const s = e.target.closest('[data-nudge-opt]'); if (!s) return; const li = s.closest('.bb-nudge__item'); const btn = li && li.querySelector('[data-nudge-add]'); const c = btn && nudgeCards[parseInt(btn.dataset.nudgeAdd, 10)]; const o = c && c.querySelector('[data-bundle-variant-opt][data-id="' + s.value + '"]'); const pr = li && li.querySelector('.bb-nudge__price'); if (!o || !pr) return; const p = parseInt(o.dataset.price, 10) || 0; pr.innerHTML = money(p) + (p >= renderNudge.gap ? '<span class="bb-nudge__tag">−' + renderNudge.pct + ' %</span>' : ''); const im = li.querySelector('img.bb-nudge__img'); if (im && o.dataset.img) im.src = o.dataset.img; }); } const pick = items.filter((x) => x.s > 0).slice(0, 4);
      if (pick.length && !pick.some((x) => x.info.price >= gap)) { const u = items.filter((x) => x.s > 0 && x.info.price >= gap && x.info.price <= cap).sort((a, b) => b.s - a.s)[0]; if (u && pick.indexOf(u) < 0) pick[pick.length - 1] = u; } pick.sort((a, b) => (b.info.price >= gap) - (a.info.price >= gap));
      if (!pick.length) { els.nudge.hidden = true; return; }
      els.nudgeTitle.innerHTML = tr('nudge_html', 'Il te manque <b>[amount]</b> pour débloquer <b>−[pct] %</b>', { amount: money(gap), pct: next.pct });
      const key = pick.map((x) => x.info.id).join(',') + '|' + gap;
      if (key !== nudgeKey) {
        nudgeKey = key;
        nudgeCards = pick.map((x) => x.c);
        els.nudgeList.innerHTML = pick.map((x, i) =>
          '<li class="bb-nudge__item">' +
          (x.info.img ? '<img class="bb-nudge__img" src="' + esc(x.info.img) + '" alt="" width="38" height="38" loading="lazy">' : '<span class="bb-nudge__img"></span>') +
          '<span class="bb-nudge__name">' + esc(x.info.title) + (optsHtml(x) ? '' : (x.info.variant ? ' <small>' + esc(x.info.variant) + '</small>' : '')) + '</span>' +
          '<span class="bb-nudge__price">' + money(x.info.price) + (x.info.price >= gap ? '<span class="bb-nudge__tag">−' + next.pct + ' %</span>' : '') + '</span>' +
          '<button type="button" class="bb-nudge__add" data-nudge-add="' + i + '" aria-label="' + esc(tr('nudge_add', 'Ajouter [title] au bundle', { title: x.info.title })) + '">+</button>' +
          optsHtml(x) + '</li>').join('');
      }
      els.nudge.hidden = false;
    }

    /* ---- Dernier palier atteint : la potion explose ---- */
    let wasFull = false;
    let booted = false;
    let burstTimer = 0;
    function splash(x, y, n) {
      const layer = document.createElement('div');
      layer.className = 'bb-splash';
      layer.style.left = x + 'px';
      layer.style.top = y + 'px';
      for (let i = 0; i < n; i++) {
        const d = document.createElement('span');
        d.className = 'bb-drop';
        d.style.setProperty('--dx', Math.round((Math.random() * 2 - 1) * 120) + 'px');
        d.style.setProperty('--dy', -Math.round(50 + Math.random() * 100) + 'px');
        d.style.setProperty('--s', Math.round(6 + Math.random() * 8) + 'px');
        d.style.setProperty('--d', (Math.random() * 0.15).toFixed(2) + 's');
        layer.appendChild(d);
      }
      root.appendChild(layer);
      setTimeout(() => layer.remove(), 1700);
    }
    function celebrate() {
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      const last = TIERS[TIERS.length - 1];
      setTimeout(() => toast('🧪 ' + tr('potion_full_toast', 'Potion pleine : −[pct] % débloqués !', { pct: last.pct })), 60);
      const potion = $('[data-bundle-potion]');
      /* Mobile (potion masquée) : les gouttes jaillissent du récap en bas d'écran */
      if (!potion || potion.offsetParent === null) {
        const h = $('[data-bundle-toggle]').getBoundingClientRect();
        splash(h.left + h.width / 2, h.top + 6, 22);
        return;
      }
      /* Ordinateur : on fait défiler la colonne de droite pour montrer la potion */
      const side = potion.closest('.bb-side');
      let wait = 0;
      if (side && side.scrollHeight > side.clientHeight) {
        const pr = potion.getBoundingClientRect();
        const sr = side.getBoundingClientRect();
        const bottom = Math.min(sr.bottom, window.innerHeight);
        const top = Math.max(sr.top, 0);
        const delta = pr.bottom > bottom ? pr.bottom - bottom + 8 : (pr.top < top ? pr.top - top - 8 : 0);
        if (delta) { side.scrollBy({ top: delta, behavior: 'smooth' }); wait = 450; }
      }
      setTimeout(() => {
        potion.classList.remove('is-burst', 'bb-paused');
        void potion.offsetWidth;
        potion.classList.add('is-burst');
        clearTimeout(burstTimer);
        burstTimer = setTimeout(() => potion.classList.remove('is-burst'), 2600);
        const f = potion.querySelector('.bb-potion__flask').getBoundingClientRect();
        if (f.top >= 0 && f.bottom <= window.innerHeight) {
          setTimeout(() => splash(f.left + f.width / 2, f.top + f.height * 0.08, 18), 330);
        } else {
          /* Potion hors écran : les gouttes partent de la barre de progression (toujours visible) */
          const pk = $('[data-bundle-progress-pk]');
          const r = (pk || els.fill).getBoundingClientRect();
          splash(pk ? r.left + r.width / 2 : r.right - 4, r.top + r.height / 2, 22);
        }
      }, wait);
    }

    /* ---- Passage de palier : citrouilles, chauves-souris et fantômes jaillissent ---- */
    let prevPct = 0;
    function tierBurst(pct) {
      const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      const spooky = root.classList.contains('bb--halloween');
      toast((spooky ? '🎃 ' : '✨ ') + tr('tier_unlocked', 'Palier −[pct] % débloqué !', { pct: pct }));
      if (reduce) return;
      const pk = $('[data-bundle-progress-pk]');
      const r = (pk || els.fill).getBoundingClientRect();
      const x = pk ? r.left + r.width / 2 : r.right - 4;
      const y = r.top + r.height / 2;
      const icons = spooky ? ['🎃', '🦇', '👻', '🎃', '🕸️', '🍬', '🦇', '🎃'] : ['✨', '🎉', '⭐', '✨'];
      const layer = document.createElement('div');
      layer.className = 'bb-boo';
      layer.style.left = x + 'px';
      layer.style.top = y + 'px';
      const n = 14;
      for (let i = 0; i < n; i++) {
        const s = document.createElement('span');
        s.className = 'bb-boo__i';
        s.textContent = icons[i % icons.length];
        const a = (Math.PI * 2 * i) / n + Math.random() * 0.5;
        const dist = 70 + Math.random() * 90;
        s.style.setProperty('--dx', Math.round(Math.cos(a) * dist) + 'px');
        s.style.setProperty('--dy', Math.round(Math.sin(a) * dist * 0.75 + 40) + 'px');
        s.style.setProperty('--rot', Math.round((Math.random() * 2 - 1) * 260) + 'deg');
        s.style.setProperty('--sz', (16 + Math.random() * 14).toFixed(0) + 'px');
        s.style.setProperty('--d', (Math.random() * 0.12).toFixed(2) + 's');
        layer.appendChild(s);
      }
      document.body.appendChild(layer);
      setTimeout(() => layer.remove(), 1600);
      if (pk) bump(pk);
    }

    /* ---- Cartes uniques disponibles (hors onglet « mix », qui contient des copies) ---- */
    function sourceCards() {
      const seen = new Set();
      const out = [];
      $$('[data-bundle-panel]:not([data-bundle-all]) [data-bundle-card], [data-bundle-panel][data-bundle-all] [data-bundle-card]').forEach((c) => {
        const u = c.dataset.productUrl;
        if (!u || seen.has(u)) return;
        seen.add(u);
        out.push(c);
      });
      return out;
    }
    const cardFor = (url) => sourceCards().find((c) => c.dataset.productUrl === url) || null;

    /* ---- Ensorcelle-moi : complète le bundle jusqu'au palier suivant ---- */
    function bewitch(btn) {
      const { subtotal, next } = compute();
      if (!next) { toast('🔮 ' + tr('bewitch_max', 'Remise maximale déjà atteinte !')); return; }
      const byCat = new Map();
      sourceCards().forEach((c) => {
        const info = readCard(c);
        if (!info || state.has(info.id) || info.id === GIFT_VARIANT || info.price <= 0 || info.max < 1) return;
        const p = c.closest('[data-bundle-panel]');
        if (p && p.hasAttribute('data-bundle-solo')) return; const k = p ? p.dataset.bundlePanel : 'x';
        if (!byCat.has(k)) byCat.set(k, []);
        byCat.get(k).push({ c, info });
      });
      const cats = [...byCat.values()].map((l) => l.sort(() => Math.random() - 0.5)).sort(() => Math.random() - 0.5);
      const target = next.min * 100;
      let sum = subtotal;
      const picked = [];
      for (let round = 0; sum < target && round < 6; round++) {
        for (const list of cats) {
          if (sum >= target || picked.length >= 6) break;
          const item = list.shift();
          if (!item) continue;
          picked.push(item);
          sum += item.info.price;
        }
        if (!cats.some((l) => l.length)) break;
      }
      if (!picked.length) return;
      if (btn) { btn.classList.remove('is-casting'); void btn.offsetWidth; btn.classList.add('is-casting'); }
      picked.forEach((p, i) => {
        setTimeout(() => {
          setQty(p.info, 1);
          p.c.classList.remove('is-bewitched');
          void p.c.offsetWidth;
          p.c.classList.add('is-bewitched');
          if (i === picked.length - 1) toast('🔮 ' + tr('bewitch_done', 'Abracadabra ! [count] produits ajoutés', { count: picked.length }));
        }, 140 * i);
      });
    }

    /* ---- Recettes du Labo (section en bas de page) : ajout en un clic ---- */
    document.addEventListener('eleven:bundle-recipe', (e) => {
      const urls = (e.detail && e.detail.urls) || [];
      let n = 0;
      urls.forEach((u) => {
        const c = cardFor(u);
        const info = c && readCard(c);
        if (!info || state.has(info.id)) return;
        setQty(info, 1);
        n++;
      });
      toast('🧙 ' + tr('recipe_added', 'Recette ajoutée à ton bundle !'));
      const target = $('.bb-progress') || root;
      const y = target.getBoundingClientRect().top + window.scrollY - 90;
      window.scrollTo({ top: Math.max(0, y), behavior: 'smooth' });
      if (e.detail && typeof e.detail.done === 'function') e.detail.done(n);
    });

    /* ---- Bundle gardé en mémoire (ce navigateur, 14 jours) ---- */
    const STORE_KEY = 'eleven-bundle:' + location.pathname;
    function save() {
      if (!booted) return;
      try {
        const lines = [];
        state.forEach((l, id) => { if (id !== GIFT_VARIANT) lines.push([id, l.qty]); });
        if (lines.length) localStorage.setItem(STORE_KEY, JSON.stringify({ t: Date.now(), lines }));
        else localStorage.removeItem(STORE_KEY);
      } catch (err) { /* stockage indisponible : on ignore */ }
    }
    function restore() {
      let saved = null;
      try { saved = JSON.parse(localStorage.getItem(STORE_KEY) || 'null'); } catch (err) { saved = null; }
      if (!saved || !Array.isArray(saved.lines) || Date.now() - (saved.t || 0) > 14 * 864e5) return 0;
      let n = 0;
      saved.lines.forEach((line) => {
        const id = String(line[0]);
        if (!/^[0-9]+$/.test(id)) return;
        const hits = $$('[data-bundle-variant-opt][data-id="' + id + '"], [data-bundle-variant-single][value="' + id + '"]');
        if (!hits.length) return;
        hits.forEach((h) => { if (h.hasAttribute('data-bundle-variant-opt')) selectVariant(h.closest('[data-bundle-card]'), h, true); });
        const info = readCard(hits[0].closest('[data-bundle-card]'));
        if (!info || info.id !== id) return;
        state.set(id, Object.assign({}, info, { qty: Math.min(Math.max(1, parseInt(line[1], 10) || 1), info.max) }));
        n++;
      });
      return n;
    }

    /* ---- Mutation de l'état ---- */
    function setQty(info, qty) {
      const next = Math.max(0, Math.min(qty, info.max));
      if (next === 0) {
        state.delete(info.id);
      } else {
        const prev = state.get(info.id) || {};
        state.set(info.id, Object.assign({}, info, prev, { qty: next, price: info.price, max: info.max }));
      }
      render();
    }

    /* ---- Calculs ---- */
    function compute() {
      let subtotal = 0;
      let count = 0;
      state.forEach((l) => { subtotal += l.price * l.qty; count += l.qty; });
      let pct = 0;
      for (const t of TIERS) if (subtotal >= t.min * 100) pct = t.pct;
      const next = TIERS.find((t) => subtotal < t.min * 100) || null;
      return { subtotal, count, pct, saving: Math.round(subtotal * pct / 100), next };
    }

    /* ---- Petites animations : rejoue une classe CSS ---- */
    let prevCount = 0;
    let prevIds = new Set();
    function bump(el) {
      if (!el) return;
      el.classList.remove('is-bump');
      void el.offsetWidth;
      el.classList.add('is-bump');
    }

    /* ---- Rendu ---- */
    function render() {
      const { subtotal, count, pct, saving, next } = compute();

      /* Lignes du récap */
      els.lines.innerHTML = '';
      state.forEach((l, id) => {
        const li = document.createElement('li');
        li.className = 'bb-line' + (prevIds.has(id) ? '' : ' is-new');
        li.dataset.lineId = id;
        li.innerHTML =
          (l.img ? '<img class="bb-line__img" src="' + l.img + '" alt="" loading="lazy" width="48" height="48">' : '<span class="bb-line__img"></span>') +
          '<div><p class="bb-line__name">' + l.title +
          (l.variant ? '<span class="bb-line__variant">' + l.variant + '</span>' : '') +
          '</p><div class="bb-line__bottom">' +
          '<div class="bb-stepper"><button type="button" class="bb-stepper__btn" data-line-step="-1" aria-label="' + esc(tr('qty_minus', 'Retirer une unité')) + '">&minus;</button>' +
          '<span class="bb-stepper__qty">' + l.qty + '</span>' +
          '<button type="button" class="bb-stepper__btn" data-line-step="1" aria-label="' + esc(tr('qty_plus', 'Ajouter une unité')) + '"' + (l.qty >= l.max ? ' disabled' : '') + '>+</button></div>' +
          '<span class="bb-line__price">' + money(l.price * l.qty) + '</span>' +
          '</div></div>' +
          '<button type="button" class="bb-line__remove" data-line-remove aria-label="' + esc(tr('remove_line', 'Supprimer [title] du bundle', { title: l.title })) + '">&times;</button>';
        els.lines.appendChild(li);
      });

      els.empty.hidden = count > 0;
      els.count.textContent = count;
      els.subtotal.textContent = money(subtotal);
      els.handleTotal.textContent = money(subtotal - saving);
      els.total.textContent = money(subtotal - saving);
      els.savingRow.hidden = saving === 0;
      els.saving.textContent = '−' + money(saving);
      els.savingPct.textContent = pct ? '(−' + pct + ' %)' : '';
      els.submit.disabled = count === 0;
      els.go.forEach((b) => { b.hidden = count === 0; });
      root.classList.toggle('has-go', count > 0);
      document.body.classList.toggle('bb-has-go', count > 0);
      if (els.goMeta) els.goMeta.textContent = count + ' ' + (count > 1 ? tr('products', 'produits') : tr('product', 'produit')) + ' · ' + money(subtotal - saving) + (pct ? ' (−' + pct + ' %)' : '');

      if (count !== prevCount) {
        bump(els.count);
        bump(els.handleTotal);
      }
      prevCount = count;
      prevIds = new Set(state.keys());

      /* Cartes : état + compteur */
      $$('[data-bundle-card]').forEach((card) => {
        const info = readCard(card);
        const line = info && state.get(info.id);
        const stepper = card.querySelector('[data-bundle-card-stepper]');
        const addBtn = card.querySelector('[data-bundle-add]');
        const qtyEl = card.querySelector('[data-bundle-card-qty]');
        if (line) {
          card.classList.add('is-in-bundle');
          addBtn.hidden = true;
          stepper.hidden = false;
          qtyEl.textContent = line.qty;
          stepper.querySelector('[data-bundle-step="1"]').disabled = line.qty >= line.max;
        } else {
          card.classList.remove('is-in-bundle');
          addBtn.hidden = false;
          stepper.hidden = true;
        }
      });

      /* Progression */
      const top = TIERS.length ? TIERS[TIERS.length - 1].min * 100 : 0;
      els.fill.style.width = top ? Math.min(100, (subtotal / top) * 100) + '%' : '0%';
      const pk = $('[data-bundle-progress-pk]');
      if (pk) pk.style.left = els.fill.style.width;

      /* Potion : se remplit avec le panier */
      const potion = $('[data-bundle-potion]');
      if (potion) {
        const lvl = top ? Math.min(1, subtotal / top) : 0;
        potion.style.setProperty('--potion', lvl.toFixed(3));
        potion.classList.toggle('is-full', lvl >= 1);
        $('[data-bundle-potion-pct]').textContent = (pct ? '−' + pct : '0') + ' %';
        const hint = $('[data-bundle-potion-hint]');
        if (hint) {
          hint.textContent = next
            ? tr('hint_more', 'Encore [amount] pour −[pct] %', { amount: money(next.min * 100 - subtotal), pct: next.pct })
            : tr('hint_full', 'Potion pleine, remise maximale !');
        }
      }
      $$('[data-notch]').forEach((n) => {
        n.style.left = top ? (parseFloat(n.dataset.notch) * 100 / top) * 100 + '%' : '0%';
      });
      $$('[data-tier-chip]').forEach((c) => {
        c.classList.toggle('is-reached', subtotal >= parseFloat(c.dataset.tierChip) * 100);
      });
      if (next) {
        els.label.innerHTML = tr('label_more_html', 'Encore <b>[amount]</b> pour débloquer <b>−[pct] %</b>', { amount: money(next.min * 100 - subtotal), pct: next.pct });
      } else if (pct) {
        els.label.innerHTML = tr('label_max_html', 'Remise maximale atteinte : <b>−[pct] %</b>', { pct: pct }) + ' \u{1F389}';
      } else {
        els.label.textContent = tr('progress_start', 'Ajoute des produits pour débloquer ta première remise.');
      }

      /* Cadeau */
      if (els.gift) {
        els.gift.hidden = !(GIFT_AMOUNT > 0 && subtotal >= GIFT_AMOUNT && !state.has(GIFT_VARIANT));
      }
      renderNudge(subtotal, count, next);

      const full = TIERS.length > 0 && !next && count > 0;
      if (booted && pct > prevPct) tierBurst(pct);
      prevPct = pct;
      if (full && !wasFull && booted) celebrate();
      wasFull = full;
      save();
    }

    /* ---- Délégation d'événements ---- */
    root.addEventListener('click', (e) => {
      const bw = e.target.closest('[data-bundle-bewitch]');
      if (bw) { bewitch(bw); return; }
      const card = e.target.closest('[data-bundle-card]');

      /* Choix d'une option (goût, batterie, grammage…) */
      const chip = e.target.closest('[data-opt-value]');
      if (chip && card) {
        const v = resolveVariant(card, chip);
        if (v && !v.classList.contains('is-selected')) selectVariant(card, v);
        return;
      }

      /* Ajout depuis le coup de pouce */
      const sugg = e.target.closest('[data-nudge-add]');
      if (sugg) {
        const c = nudgeCards[parseInt(sugg.dataset.nudgeAdd, 10)]; const nLi = sugg.closest('.bb-nudge__item'); const nSel = nLi ? nLi.querySelector('[data-nudge-opt]') : null; if (c && nSel) { const want = c.querySelector('[data-bundle-variant-opt][data-id="' + nSel.value + '"]'); if (want && !want.classList.contains('is-selected')) selectVariant(c, want, true); }
        const info = c && readCard(c);
        if (info) {
          setQty(info, 1);
          toast((root.classList.contains('bb--halloween') ? '🎃 ' : '✓ ') + tr('added', 'Ajouté à ton bundle'));
        }
        return;
      }

      /* Clic sur l'image : ajoute directement au bundle (+1 à chaque clic) */
      const media = e.target.closest('[data-bundle-media-add]');
      if (media && card) {
        const now = Date.now();
        if (now - (card._bbTap || 0) < 450) return; /* anti double-tap involontaire */
        card._bbTap = now;
        const info = readCard(card);
        if (!info) return;
        const cur = (state.get(info.id) || {}).qty || 0;
        if (cur >= info.max) { toast('⚠️ ' + tr('max', 'Stock maximum atteint pour ce produit')); return; }
        setQty(info, cur + 1);
        media.classList.remove('is-tapped');
        void media.offsetWidth;
        media.classList.add('is-tapped');
        const p1 = document.createElement('span');
        p1.className = 'bb-card__plus1';
        p1.textContent = '+1';
        media.appendChild(p1);
        p1.addEventListener('animationend', () => p1.remove());
        toast((root.classList.contains('bb--halloween') ? '🎃 ' : '✓ ') + tr('added', 'Ajouté à ton bundle') + (cur > 0 ? ' (×' + (cur + 1) + ')' : ''));
        return;
      }

      if (e.target.closest('[data-bundle-checkout]')) { submit(GO_TARGET); return; }

      if (e.target.closest('[data-bundle-add]')) {
        const info = readCard(card);
        if (info) {
          setQty(info, 1);
          toast((root.classList.contains('bb--halloween') ? '🎃 ' : '✓ ') + tr('added', 'Ajouté à ton bundle'));
        }
        return;
      }
      const step = e.target.closest('[data-bundle-step]');
      if (step && card) {
        const info = readCard(card);
        const cur = (state.get(info.id) || {}).qty || 0;
        setQty(info, cur + parseInt(step.dataset.bundleStep, 10));
        return;
      }
      const lineStep = e.target.closest('[data-line-step]');
      if (lineStep) {
        const id = lineStep.closest('.bb-line').dataset.lineId;
        const l = state.get(id);
        if (l) setQty(l, l.qty + parseInt(lineStep.dataset.lineStep, 10));
        return;
      }
      if (e.target.closest('[data-line-remove]')) {
        state.delete(e.target.closest('.bb-line').dataset.lineId);
        render();
        return;
      }
      const tab = e.target.closest('[data-bundle-tab]');
      if (tab) {
        const id = tab.dataset.bundleTab;
        $$('[data-bundle-tab]').forEach((t) => {
          const on = t === tab;
          t.classList.toggle('is-active', on);
          t.setAttribute('aria-selected', on ? 'true' : 'false');
        });
        $$('[data-bundle-panel]').forEach((p) => {
          const on = p.dataset.bundlePanel === id;
          p.classList.toggle('is-hidden', !on);
          p.hidden = !on;
        });
        return;
      }
      if (e.target.closest('[data-bundle-more]')) {
        const btn = e.target.closest('[data-bundle-more]');
        $$('.bb-card.is-overflow', btn.closest('[data-bundle-panel]')).forEach((c) => { c.hidden = false; });
        btn.remove();
        render();
        return;
      }
      if (e.target.closest('[data-bundle-toggle]')) {
        setSheet(!els.summary.classList.contains('is-open'));
        return;
      }
      if (e.target.closest('[data-bundle-gift-add]') && GIFT_VARIANT) {
        setQty({ id: GIFT_VARIANT, price: 0, max: 1, title: tr('gift_title', 'Cadeau offert'), variant: '', img: '' }, 1);
        return;
      }
      if (e.target.closest('[data-bundle-submit]')) submit();
    });

    /* Navigation clavier dans un groupe d'options (flèches) */
    root.addEventListener('keydown', (e) => {
      const opt = e.target.closest('[data-opt-value]');
      if (!opt || ['ArrowRight', 'ArrowLeft', 'ArrowDown', 'ArrowUp'].indexOf(e.key) < 0) return;
      const list = $$('[data-opt-value]', opt.parentElement);
      const i = list.indexOf(opt) + (e.key === 'ArrowRight' || e.key === 'ArrowDown' ? 1 : -1);
      const target = list[(i + list.length) % list.length];
      e.preventDefault();
      target.focus();
      target.click();
    });

    /* ---- Onglet « tous les produits » ----
       Copie les cartes des autres onglets, puis les range en alternant
       les catégories : les N premiers produits = un de chaque type.
       Dans chaque catégorie, les produits de la collection de l'onglet
       (tag « bundle ») passent en premier. */
    const VISIBLE = parseInt(root.dataset.visible, 10) || 12;
    $$('[data-bundle-panel][data-bundle-all]').forEach((panel) => {
      const grid = panel.querySelector('.bb-grid');
      const own = $$('[data-bundle-card]', grid);
      const featured = new Set(own.map((c) => c.dataset.productUrl)); const pinned = own.filter((c) => c.hasAttribute('data-bundle-pinned')); const pinnedUrls = new Set(pinned.map((c) => c.dataset.productUrl));
      const seen = new Set();
      const groups = [];

      $$('[data-bundle-panel]:not([data-bundle-all]):not([data-bundle-solo])').forEach((src) => {
        const list = $$('[data-bundle-card]', src)
          .filter((c) => !seen.has(c.dataset.productUrl))
          .sort((a, b) => featured.has(b.dataset.productUrl) - featured.has(a.dataset.productUrl));
        list.forEach((c) => seen.add(c.dataset.productUrl));
        if (list.length) groups.push({ w: parseInt(src.dataset.mixWeight, 10) || 1, items: list.map((c) => c.cloneNode(true)) });
      });
      const orphans = own.filter((c) => !seen.has(c.dataset.productUrl));
      if (orphans.length) groups.unshift({ w: 1, items: orphans }); const extra = (panel.dataset.mixExtra || '').split(',').filter(Boolean); if (extra.length) { const exItems = []; $$('[data-bundle-card]').forEach((c) => { const u = c.dataset.productUrl; if (extra.indexOf(u) < 0 || seen.has(u) || c.closest('[data-bundle-all]')) return; seen.add(u); exItems.push(c.cloneNode(true)); }); if (exItems.length) groups.push({ w: 1, items: exItems }); }

      /* Les catégories au poids le plus fort passent devant et
         placent plus de produits à chaque tour. */
      groups.sort((a, b) => b.w - a.w);
      groups.forEach((g) => { g.items = g.items.filter((c) => !pinnedUrls.has(c.dataset.productUrl)); }); const ordered = pinned.slice();
      while (groups.some((g) => g.items.length)) {
        groups.forEach((g) => { ordered.push(...g.items.splice(0, g.w)); });
      }

      grid.innerHTML = '';
      $$('.bb-more, .bb-panel__empty', panel).forEach((el) => el.remove());
      ordered.forEach((c, i) => {
        const over = i >= VISIBLE;
        c.hidden = over;
        c.classList.toggle('is-overflow', over);
        c.classList.remove('is-in-bundle');
        grid.appendChild(c);
      });
      if (ordered.length > VISIBLE) {
        const btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'bb-more';
        btn.setAttribute('data-bundle-more', '');
        btn.innerHTML = esc(tr('see_all', 'Voir tout')) + ' <span class="bb-more__count">(' + ordered.length + ' ' + esc(tr('products', 'produits')) + ')</span><span class="bb-more__arrow" aria-hidden="true"><svg class="bb-arrow" viewBox="0 0 18 24" width="14" height="19" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"><path d="M9 2c-4 5 4 9 0 17"/><path d="M4 15l5 6 5-6"/></svg></span>';
        panel.appendChild(btn);
      }
    });

    /* ---- Compte à rebours jusqu'à la fin de la saison ---- */
    const cd = $('[data-bundle-countdown]');
    if (cd) {
      const end = Date.parse(cd.dataset.bundleCountdown);
      const out = cd.querySelector('[data-bundle-countdown-value]');
      const pad = (n) => String(n).padStart(2, '0');
      const tick = () => {
        const ms = end - Date.now();
        if (!(ms > 0)) { cd.hidden = true; return false; }
        const d = Math.floor(ms / 864e5);
        const h = Math.floor(ms / 36e5) % 24;
        const m = Math.floor(ms / 6e4) % 60;
        const sec = Math.floor(ms / 1e3) % 60;
        out.textContent = (d ? d + ' ' + tr('day_short', 'j') + ' ' : '') + pad(h) + ' h ' + pad(m) + ' min ' + pad(sec) + ' s';
        cd.hidden = false;
        return true;
      };
      if (tick()) setInterval(tick, 1000);
    }

    /* ---- Mode Halloween : citrouille sur l'onglet mis en avant ---- */
    if (root.classList.contains('bb--halloween')) {
      $$('.bb-tab__icon').forEach((i) => { i.textContent = '🎃'; });
    }

    /* ---- Nombre de produits disponibles sur chaque onglet ---- */
    $$('[data-bundle-tab]').forEach((tab) => {
      const panel = root.querySelector('#bb-panel-' + tab.dataset.bundleTab);
      const n = panel ? panel.querySelectorAll('[data-bundle-card]').length : 0;
      const badge = document.createElement('span');
      badge.className = 'bb-tab__count';
      badge.textContent = n;
      badge.setAttribute('aria-label', n + ' ' + tr('products', 'produits'));
      tab.appendChild(badge);
    });

    /* ---- Visuel « labo » de la bannière : un produit par catégorie ---- */
    const visual = $('[data-bundle-hero-visual]');
    if (visual) {
      const mix = $('[data-bundle-panel][data-bundle-all] .bb-grid');
      const source = mix ? $$('[data-bundle-card]', mix) : $$('[data-bundle-panel] [data-bundle-card]:first-child');
      const pics = [];
      const used = new Set();
      source.forEach((c) => {
        const img = c.querySelector('.bb-card__media img');
        const src = img && img.getAttribute('src');
        if (src && pics.length < 4 && !used.has(src)) { used.add(src); pics.push(src); }
      });
      pics.forEach((src, i) => {
        const f = document.createElement('span');
        f.className = 'bb-float bb-float--' + (i + 1);
        f.innerHTML = '<img src="' + src + '" alt="" width="200" height="200" decoding="async">';
        visual.appendChild(f);
      });
      if (!pics.length) visual.remove();
    }

    /* ---- Bouton « Commencer mon bundle » : défilement doux sous le header ---- */
    root.addEventListener('click', (e) => {
      const start = e.target.closest('[data-bundle-start]');
      if (!start) return;
      const target = root.querySelector(start.getAttribute('href'));
      if (!target) return;
      e.preventDefault();
      const offset = (lastTop > 0 ? lastTop : 0) + (els.progress ? els.progress.offsetHeight : 0) + 16;
      window.scrollTo({ top: target.getBoundingClientRect().top + window.scrollY - offset, behavior: 'smooth' });
    });

    /* ---- Pause des animations hors écran (économise la batterie mobile) ---- */
    if ('IntersectionObserver' in window) {
      const io = new IntersectionObserver((entries) => {
        entries.forEach((en) => en.target.classList.toggle('bb-paused', !en.isIntersecting));
      }, { rootMargin: '120px' });
      $$('.bb-hero, .bb-potion').forEach((el) => io.observe(el));
    }

    /* ---- Effet « ripple » au clic sur les boutons ---- */
    const RIPPLE = '.bb-card__add, .bb-submit, .bb-more, .bb-tab, .bb-opt, .bb-stepper__btn, .bb-gift__btn';
    root.addEventListener('pointerdown', (e) => {
      const btn = e.target.closest(RIPPLE);
      if (!btn || btn.disabled || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      const r = btn.getBoundingClientRect();
      const size = Math.max(r.width, r.height) * 2;
      const dot = document.createElement('span');
      dot.className = 'bb-ripple';
      dot.style.width = dot.style.height = size + 'px';
      dot.style.left = (e.clientX - r.left - size / 2) + 'px';
      dot.style.top = (e.clientY - r.top - size / 2) + 'px';
      btn.appendChild(dot);
      dot.addEventListener('animationend', () => dot.remove());
    });

    /* ---- Envoi au panier, en un seul appel ---- */
    async function applyBundleCode() { /* Remise bundle : code appliqué UNIQUEMENT depuis cette page (codes Shopify « Bundle Labo Eleven », collection bundle-halloween-eligibles). Palier calculé sur les seules lignes _bundle. */ const CODES = { 10: 'LABO10-YVFIOT', 15: 'LABO15-1HS65G', 20: 'LABO20-3WEIT8', 25: 'LABO25-I6M2XT' }; const cart = await fetch('/cart.js', { headers: { Accept: 'application/json' } }).then((r) => r.json()); const rate = parseFloat(window.Shopify && Shopify.currency && Shopify.currency.rate) || 1; let sub = 0; (cart.items || []).forEach((it) => { if (it.properties && it.properties._bundle) sub += it.original_line_price; }); let pct = 0; for (const t of TIERS) if (sub >= t.min * 100 * rate) pct = t.pct; const code = CODES[pct]; if (!code) return; await fetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ discount: code }) }); } async function submit(dest) {
      const items = [];
      state.forEach((l, id) => items.push({ id: Number(id), quantity: l.qty, properties: { _bundle: 'Compose ton bundle' } }));
      if (!items.length) return;

      els.error.hidden = true;
      els.submit.classList.add('is-loading');
      els.submit.textContent = tr('adding', 'Ajout en cours…');
      els.go.forEach((b) => { b.classList.add('is-loading'); b.disabled = true; const l = b.querySelector('.bb-go__label'); if (l) { l.dataset.txt = l.dataset.txt || l.textContent; l.textContent = tr('adding', 'Ajout en cours…'); } });

      try {
        const res = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items })
        });
        if (!res.ok) {
          const err = await res.json().catch(() => ({}));
          throw new Error(err.description || tr('add_error', 'Ajout impossible'));
        }
        try { localStorage.removeItem(STORE_KEY); } catch (err) { /* rien */ } try { await applyBundleCode(); } catch (err) { /* la remise ne bloque jamais l'ajout */ }
        if (dest) {
          window.location.href = dest;
        } else if (AFTER_ADD === 'drawer') {
          document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
          document.dispatchEvent(new CustomEvent('cart:open', { bubbles: true }));
          setTimeout(() => { window.location.href = '/cart'; }, 1200);
        } else {
          window.location.href = '/cart';
        }
      } catch (err) {
        els.error.textContent = err.message + ' — ' + tr('reload_hint', 'recharge la page et réessaie.');
        els.error.hidden = false;
        els.submit.classList.remove('is-loading');
        els.submit.textContent = tr('submit', 'Ajouter mon bundle au panier');
        els.go.forEach((b) => { b.classList.remove('is-loading'); b.disabled = false; const l = b.querySelector('.bb-go__label'); if (l && l.dataset.txt) l.textContent = l.dataset.txt; });
        if (dest) setSheet(true);
      }
    }

    /* État initial des options, puis bundle gardé en mémoire */
    $$('[data-bundle-card]').forEach(syncChips);
    const restored = restore();
    render();
    prevPct = compute().pct;
    booted = true;
    const settle = () => setTimeout(() => root.classList.add('is-settled'), 600);
    if (document.readyState === 'complete') settle(); else window.addEventListener('load', settle, { once: true });
    if (restored) toast('🧪 ' + tr(restored > 1 ? 'restored_other' : 'restored_one', 'On a gardé ton bundle ([count] produit' + (restored > 1 ? 's' : '') + ')', { count: restored }));
  }

  function boot() {
    document.querySelectorAll('[data-bundle-root]').forEach(initBundle);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  document.addEventListener('shopify:section:load', (e) => {
    const r = e.target.querySelector('[data-bundle-root]');
    if (r) { r.dataset.bundleReady = ''; initBundle(r); }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["eleven-lab-results"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initElevenLab = (root) => {
      if (!root || root.dataset.elevenLabInitialized === 'true') return;
      root.dataset.elevenLabInitialized = 'true';

      const search = root.querySelector('[data-eleven-lab-search]');
      const filters = Array.from(root.querySelectorAll('[data-eleven-lab-filter]'));
      const cards = Array.from(root.querySelectorAll('[data-eleven-lab-card]'));
      const count = root.querySelector('[data-eleven-lab-count]');
      const empty = root.querySelector('[data-eleven-lab-empty]');
      const modal = root.querySelector('[data-eleven-lab-modal]');
      const modalBody = root.querySelector('[data-eleven-lab-modal-body]');
      const modalTitle = root.querySelector('[data-eleven-lab-modal-title]');
      const modalOpeners = Array.from(root.querySelectorAll('[data-eleven-lab-open-coa]'));
      const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      let activeFilter = 'all';
      let lastModalTrigger = null;
      let lastCount = null;
      let modalCloseTimer = null;
      let searchFrame = null;
      let revealObserver = null;
      const readbar = root.querySelector('[data-eleven-lab-readbar]');
      const readbarFill = readbar ? readbar.querySelector('span') : null;
      let readbarFrame = null;

      const updateReadbar = () => {
        if (!readbar || !readbarFill) return;
        const rootRect = root.getBoundingClientRect();
        const rootTop = window.scrollY + rootRect.top;
        const rootBottom = rootTop + root.offsetHeight;
        const scrollStart = rootTop;
        const scrollEnd = Math.max(scrollStart + 1, rootBottom - window.innerHeight);
        const ratio = Math.min(1, Math.max(0, (window.scrollY - scrollStart) / (scrollEnd - scrollStart)));
        readbarFill.style.transform = `scaleX(${ratio})`;
        readbar.setAttribute('data-progress', String(Math.round(ratio * 100)));
      };

      const requestReadbarUpdate = () => {
        if (readbarFrame) return;
        readbarFrame = requestAnimationFrame(() => {
          readbarFrame = null;
          updateReadbar();
        });
      };

      if (readbar) {
        window.addEventListener('scroll', requestReadbarUpdate, { passive: true });
        window.addEventListener('resize', requestReadbarUpdate, { passive: true });
        updateReadbar();
      }

      const normalize = (value) =>
        (value || '')
          .toLocaleLowerCase(document.documentElement.lang || undefined)
          .normalize('NFD')
          .replace(/[\u0300-\u036f]/g, '')
          .trim();

      const updateCount = (total) => {
        if (!count) return;
        count.textContent = total === 1 ? `1 ${root.dataset.countSingular || ''}`.trim() : `${total} ${root.dataset.countPlural || ''}`.trim();

        if (!reducedMotion && lastCount !== null && total !== lastCount) {
          count.classList.remove('is-updating');
          void count.offsetWidth;
          count.classList.add('is-updating');
        }
        lastCount = total;
      };

      const animateFilteredCards = (visibleCards) => {
        if (reducedMotion || typeof Element.prototype.animate !== 'function') return;

        visibleCards.slice(0, 12).forEach((card, index) => {
          if (card.classList.contains('is-reveal-pending')) return;
          card.animate(
            [
              { transform: 'translateY(7px) scale(0.994)', opacity: 0.82 },
              { transform: 'translateY(0) scale(1)', opacity: 1 }
            ],
            {
              duration: 260,
              delay: Math.min(index * 26, 156),
              easing: 'cubic-bezier(0.2, 0.8, 0.2, 1)',
              fill: 'none'
            }
          );
        });
      };

      const applyFilters = (animateResults = false) => {
        const query = normalize(search ? search.value : '');
        const visibleCards = [];

        cards.forEach((card) => {
          const categoryMatches = activeFilter === 'all' || card.dataset.category === activeFilter;
          const searchMatches = !query || normalize(card.dataset.search).includes(query);
          const shouldShow = categoryMatches && searchMatches;

          card.hidden = !shouldShow;
          if (shouldShow) visibleCards.push(card);
        });

        updateCount(visibleCards.length);
        if (empty) empty.classList.toggle('is-hidden', visibleCards.length > 0);
        if (animateResults) animateFilteredCards(visibleCards);
      };

      const setupScrollReveal = () => {
        if (reducedMotion || !('IntersectionObserver' in window)) {
          cards.forEach((card) => card.classList.add('is-revealed'));
          return;
        }

        revealObserver = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              if (!entry.isIntersecting) return;
              const card = entry.target;
              card.classList.remove('is-reveal-pending');
              card.classList.add('is-revealed');
              revealObserver.unobserve(card);
            });
          },
          { rootMargin: '0px 0px -32px 0px', threshold: 0.08 }
        );

        cards.forEach((card, index) => {
          if (index < 6) {
            card.classList.add('is-revealed');
            return;
          }
          card.classList.add('is-reveal-pending');
          revealObserver.observe(card);
        });
      };

      const getModalFocusables = () => {
        if (!modal) return [];
        return Array.from(
          modal.querySelectorAll('button:not([disabled]), a[href], input:not([disabled]), [tabindex]:not([tabindex="-1"])')
        ).filter((element) => element.offsetParent !== null);
      };

      const finishCloseModal = () => {
        if (!modal) return;
        modal.hidden = true;
        if (modalBody) modalBody.replaceChildren();
        document.body.classList.remove('eleven-lab-modal-open');
        if (lastModalTrigger) lastModalTrigger.focus();
        lastModalTrigger = null;
      };

      const closeModal = () => {
        if (!modal || modal.hidden) return;
        window.clearTimeout(modalCloseTimer);
        modal.classList.remove('is-open');
        modal.setAttribute('aria-hidden', 'true');

        if (reducedMotion) {
          finishCloseModal();
          return;
        }

        modalCloseTimer = window.setTimeout(finishCloseModal, 240);
      };

      const openModal = (button) => {
        if (!modal || !modalBody) return;
        const templateId = button.dataset.elevenLabTemplate;
        const template = templateId ? root.querySelector(`#${templateId}`) : null;
        if (!template) return;

        window.clearTimeout(modalCloseTimer);
        lastModalTrigger = button;
        modalBody.replaceChildren(template.content.cloneNode(true));

        modalBody.querySelectorAll('.eleven-lab-modal__page').forEach((page, index) => {
          page.style.setProperty('--coa-page-delay', `${Math.min(index * 55, 275)}ms`);
        });

        if (modalTitle) modalTitle.textContent = button.dataset.elevenLabTitle || root.dataset.modalDefaultTitle || '';
        modal.hidden = false;
        modal.setAttribute('aria-hidden', 'false');
        document.body.classList.add('eleven-lab-modal-open');

        requestAnimationFrame(() => {
          modal.classList.add('is-open');
          const closeButton = modal.querySelector('.eleven-lab-modal__close');
          if (closeButton) closeButton.focus({ preventScroll: true });
        });
      };

      modalOpeners.forEach((button) => {
        button.addEventListener('click', () => openModal(button));
      });

      if (modal) {
        modal.querySelectorAll('[data-eleven-lab-close-coa]').forEach((button) => {
          button.addEventListener('click', closeModal);
        });
      }

      root.addEventListener('keydown', (event) => {
        if (!modal || modal.hidden) return;

        if (event.key === 'Escape') {
          event.preventDefault();
          closeModal();
          return;
        }

        if (event.key === 'Tab') {
          const focusables = getModalFocusables();
          if (!focusables.length) return;
          const first = focusables[0];
          const last = focusables[focusables.length - 1];

          if (event.shiftKey && document.activeElement === first) {
            event.preventDefault();
            last.focus();
          } else if (!event.shiftKey && document.activeElement === last) {
            event.preventDefault();
            first.focus();
          }
        }
      });

      filters.forEach((button) => {
        button.addEventListener('click', () => {
          activeFilter = button.dataset.elevenLabFilter || 'all';

          filters.forEach((item) => {
            const isActive = item === button;
            item.classList.toggle('is-active', isActive);
            item.setAttribute('aria-pressed', isActive ? 'true' : 'false');
          });

          applyFilters(true);
        });
      });

      if (search) {
        search.addEventListener('input', () => {
          if (searchFrame) cancelAnimationFrame(searchFrame);
          searchFrame = requestAnimationFrame(() => applyFilters(true));
        });
      }

      setupScrollReveal();
      applyFilters(false);
    };

    const initAll = (scope = document) => {
      scope.querySelectorAll('[data-eleven-lab-root]').forEach(initElevenLab);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initAll());
    } else {
      initAll();
    }

    document.addEventListener('shopify:section:load', (event) => initAll(event.target));
  })();

  } catch(e) { console.error(e); }
})();
})();
